import { createContext } from 'react';

export const defaultItemConfig: InfiniteMediaItemConfigProps = {
  hideTagBar: false,
  hideContactTagging: false,
  hideInteractionStats: false,
  showDownloadLink: false,
  selectMode: false,
};

export interface InfiniteMediaItemConfigProps {
  hideTagBar?: boolean;
  hideContactTagging?: boolean;
  hideInteractionStats?: boolean;
  showDownloadLink?: boolean;
  selectMode?: boolean;
}

export default createContext<InfiniteMediaItemConfigProps>(defaultItemConfig);
